
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import Utils from "../../constant/Utils";
import * as api from "../../constant/API";

const PieCount = () => {

    const [sportList, setSportList] = useState([]);
    const [percent, setPercent] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        setIsLoading(true);
        setTimeout(() => {
            insSportCount();
        }, 1000)
    }, [])

    function insSportCount() {
        const getInsSprtCount = api.instStudCountSprt;
        fetch(getInsSprtCount, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((insResponse) => insResponse.json())
            .then((insResult) => {
                if (insResult.error == true) {
                    if (insResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    setSportList(insResult.data)
                    setIsLoading(false);
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the institute student count list", error)
                setIsLoading(false);
            })
    }

    const totCoach = sportList.reduce((total, sport) => {
        return total + parseInt(sport.sportCoachCount, 10); // Convert string to number
    }, 0);

    const series = sportList.map(sport =>
        ((parseInt(sport.sportCoachCount, 10) / totCoach) * 100).toFixed(2)
    ).map(Number);

    // Extract labels as sportName
    const labels = sportList.map(sport => sport.sportName);

    const pieChartOptions = {
        chart: {
            height: 400,
            type: "pie",
            toolbar: {
                show: false,
            },
        },
        legend: {
            position: "bottom", // Positions legends at the bottom
            horizontalAlign: "center", // Centers the legends
            fontSize: "14px",
            labels: {
                colors: ["#000"], // Legend text color
            },
            markers: {
                width: 12,
                height: 12,
                radius: 2, // Rounded corners for legend markers
            },
            itemMargin: {
                horizontal: 10,
                vertical: 5,
            },
        },
        dataLabels: {
            enabled: true,
            style: {
                fontSize: "12px",
                fontWeight: "bold",
                colors: ["#000"], // Label colors
            },
            dropShadow: {
                enabled: false, // Disable shadow for labels
            },
            formatter: function (val, opts) {
                return `${opts.w.globals.labels[opts.seriesIndex]}: ${val.toFixed(1)} %`;
            },
            textAnchor: "middle",
            distributed: true, // Distributes labels evenly
            offsetY: 0,
            offsetX: 0,
            background: {
                enabled: false, // No label background
            },
        },
        plotOptions: {
            pie: {
                dataLabels: {
                    offset: 20, // Moves labels outside the pie
                    minAngleToShowLabel: 10, // Show labels only for slices with sufficient size
                    connector: {
                        enabled: true, // Enable connector/arrow lines
                        style: {
                            color: "#000", // Connector line color
                            width: 1, // Line thickness
                            length: 10, // Line length
                        },
                    },
                },
                expandOnClick: true, // Allow slices to expand on click
                customScale: 1, // Adjusts the size of the pie chart
            },
        },
        stroke: {
            show: true,
            width: 1,
            colors: ["#fff"], // Adds a thin white border between slices
        },
        responsive: [
            {
                breakpoint: 800, // Adjusts for small screens
                options: {
                    chart: {
                        height: 300,
                    },
                    legend: {
                        fontSize: "10px",
                    },
                },
            },
        ],
        series: series, // Updated series with calculated percentages
        labels: labels, // Updated labels with sport names


    };



    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}

            <div className="card dashboard-card statistic-simply">
                <div className="card-body mb-10">
                    <ReactApexChart
                        options={pieChartOptions}
                        series={pieChartOptions.series}
                        type="pie"
                        height={400}
                        width="100%"
                    />
                </div>
            </div>
        </>
    );
}

export default PieCount;